import api from '@/services/Api';
import Impfempfehlung from '@/types/Impfempfehlung';
import { successSwal } from '@/helper/swals';
import { ActionContext, Module } from 'vuex';
import { ImpfempfehlungenState, RootState } from '@/store/types';
import { DataResponse } from '@/types';

export type ImpfempfehlungFilter = {
    gueltig: string;
};

export type LoadImpfempfehlungPayload = {
    filter: ImpfempfehlungFilter;
};

export type UpdateImpfempfehlungPayload = {
    impfempfehlung: Impfempfehlung;
    filter: ImpfempfehlungFilter;
};

export type DeleteImpfempfehlungPayload = {
    impfempfehlung: Partial<Impfempfehlung>;
    filter: ImpfempfehlungFilter;
};

export type LoadImpfempfehlungenData = DataResponse<Partial<Impfempfehlung>[]>;

type Context = ActionContext<ImpfempfehlungenState, RootState>;

export const impfempfehlungen: Module<ImpfempfehlungenState, RootState> = {
    namespaced: true,
    state: {
        dialogs: {
            edit: false,
        },
        loaders: {
            save: false,
            delete: false,
            impfempfehlungen: false,
        },
        impfempfehlungen: [],
    },
    actions: {
        loadImpfempfehlungen({ commit }: Context, payload?: LoadImpfempfehlungPayload): void {
            commit('setLoadersImpfempfehlungen', true);

            api.post<LoadImpfempfehlungenData>('verwaltung/impfempfehlungen/load', payload)
                .then((response) => commit('setImpfempfehlungen', response.data))
                .catch(console.error)
                .finally(() => commit('setLoadersImpfempfehlungen', false));
        },
        updateImpfempfehlung({ commit, dispatch }: Context,
                             { impfempfehlung, filter }: UpdateImpfempfehlungPayload): void {
            commit('setLoadersSave', true);

            api.post<Impfempfehlung>('verwaltung/impfempfehlungen/speichern', impfempfehlung)
                .then(() => {
                    successSwal('Impfempfehlung', 'gespeichert');
                    dispatch('loadImpfempfehlungen', { filter });
                    commit('setDialogsDetail', false);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersSave', false));
        },
        deleteImpfempfehlung({ commit, dispatch }: Context,
                             { impfempfehlung, filter }: DeleteImpfempfehlungPayload): void {
            commit('setLoadersDelete', true);

            api.post<Impfempfehlung>('verwaltung/impfempfehlungen/loeschen', impfempfehlung)
                .then(() => {
                    successSwal('Impfempfehlung', 'gelöscht');
                    dispatch('loadImpfempfehlungen', { filter });
                    commit('setDialogsDetail', false);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersDelete', false));
        },
    },
    mutations: {
        setImpfempfehlungen(state: ImpfempfehlungenState, { body }: LoadImpfempfehlungenData): void {
            state.impfempfehlungen = body.map((data) => new Impfempfehlung(data));
        },
        setDialogsDetail(state: ImpfempfehlungenState, visible: boolean): void {
            state.dialogs.edit = visible;
        },
        setLoadersSave(state: ImpfempfehlungenState, visible: boolean): void {
            state.loaders.save = visible;
        },
        setLoadersDelete(state: ImpfempfehlungenState, visible: boolean): void {
            state.loaders.delete = visible;
        },
        setLoadersImpfempfehlungen(state: ImpfempfehlungenState, visible: boolean): void {
            state.loaders.impfempfehlungen = visible;
        },
    },
};
